/* eslint-disable jsx-a11y/media-has-caption */
import { FC } from "react";
import InfoModalContainer from "./InfoModal";

const InfoModalVideo: FC<{
    content: string;
    show: boolean;
    setShow: (state: boolean) => void;
}> = ({ content, show, setShow }) => {
    return (
        <InfoModalContainer title="" show={show} setShow={setShow}>
            <video className="w-100 h-100" controls title="review video">
                <source src={content} />
            </video>
        </InfoModalContainer>
    );
};

export default InfoModalVideo;
